import { contentStyles, h5, paragraphLarge, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
import { BookEventFormStyles } from '../../BookEventForm.styles';
const Container = styled(BookEventFormStyles.FormBase) `
  scroll-margin: var(--scrollOffset, 0px) 0 0;
`;
const ConfirmationTitle = styled.h3 `
  ${h5}
`;
const Description = styled.div `
  ${contentStyles};

  margin: 0 0 32px;

  p {
    ${paragraphSmall};
  }
`;
const TotalPrice = styled.p `
  ${paragraphLarge};

  font-weight: bold;

  span {
    font-weight: normal;
  }

  span[data-discounted='true'] {
    text-decoration: line-through;
    opacity: 0.8;
  }
`;
const Form = styled.form ``;
export const StepThreeStyles = {
    Container,
    Description,
    Form,
    ConfirmationTitle,
    TotalPrice,
};
